import { toast } from "react-toastify"
import { api } from "../../Lib/constants"
import { ADD_TIMESHEET, ADD_TIMESHEET_FAILED, ADD_TIMESHEET_SUCCESS, TIMESHEET, TIMESHEET_FAILED, TIMESHEET_SUCCESS, UPDATE_TIMESHEET, UPDATE_TIMESHEET_FAILED, UPDATE_TIMESHEET_SUCCESS } from "./actionTypes"
import { getAuthHeader } from "../../Lib/utils"


export const getTimesheets = () => async (dispatch) => {
  dispatch({
    type: TIMESHEET,
  });
  try {
    let response = await api(`timesheet/timesheetList`, "get", {}, getAuthHeader());
    dispatch({
      type: TIMESHEET_SUCCESS,
      payload: response?.data,
    });
    return response;
  } catch (error) {
    console.log("while fetching Timesheet list error ====>", error);
    return dispatch({
      type: TIMESHEET_FAILED,
      payload: error?.message,
    });
  }
};

export const addTimesheet = (data) => async dispatch => {
  dispatch({
    type: ADD_TIMESHEET
  })
  try {
    let response = await api(`timesheet/add`, 'post', data, getAuthHeader())
    console.log('add timesheet data', response);
    toast.success("Added Successfully");
    dispatch({
      type: ADD_TIMESHEET_SUCCESS,
      payload: response?.data
    })
    return response
  } catch (error) {
    console.log("while Adding timesheet error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: ADD_TIMESHEET_FAILED,
      payload: error?.message
    })
  }
}

export const updateTimesheet = (id, data) => async dispatch => {
  dispatch({
    type: UPDATE_TIMESHEET
  })
  try {
    let response = await api(`timesheet/update/${id}`, 'put', data, getAuthHeader())
    console.log('update timesheet data', response);
    toast.success("Updated Successfully");
    dispatch({
      type: UPDATE_TIMESHEET_SUCCESS,
      payload: response?.data
    })
    return response
  } catch (error) {
    console.log("while updating timesheet error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: UPDATE_TIMESHEET_FAILED,
      payload: error?.message
    })
  }
}